import { create } from 'apisauce';
import { aws } from '../config';

const apiClient = create({
  baseURL: aws.oddApiGateway.URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
    // Authorization: bzAuthToken ? `Bearer ${bzAuthToken}` : ''
  },
  timeout: 20000
});

async function getBugCounts() {
  const response = await apiClient.get(`/bugs/countsDashboard`);
  if (response.status === 200 || response.status === 201) return response.data ? response.data : null;
  throw new Error('Request Failed');
}

async function getSettings() {
  const response = await apiClient.get(`/settings`);
  if (response.status === 200 || response.status === 201) return response.data ? response.data : null;
  throw new Error('Request Failed');
}

export default {
  apiClient,
  getBugCounts,
  getSettings
};
